<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 全局筛选组件样式 - 日期选择器 */
.arco-picker {
  background-color: #fff !important;
  border: 1px solid #e5e6eb !important;
  border-radius: 4px !important;
}

.arco-picker:hover {
  border-color: #165dff !important;
}

.arco-picker-focused {
  border-color: #165dff !important;
}

/* 全局筛选组件样式 - 选择器 */
.arco-select-view-single,
.arco-select-view-multiple {
  background-color: #fff !important;
  border: 1px solid #e5e6eb !important;
  border-radius: 4px !important;
}

.arco-select-view-single:hover,
.arco-select-view-multiple:hover {
  border-color: #165dff !important;
}

.arco-select-focused .arco-select-view-single,
.arco-select-focused .arco-select-view-multiple {
  border-color: #165dff !important;
}

/* 全局筛选组件样式 - 输入框 */
.arco-input-wrapper {
  background-color: #fff !important;
  border: 1px solid #e5e6eb !important;
  border-radius: 4px !important;
}

.arco-input-wrapper:hover {
  border-color: #165dff !important;
}

.arco-input-focus {
  border-color: #165dff !important;
}

/* 筛选组件标签样式 */
.select-label {
  color: #1d2129;
  white-space: nowrap;
}

/* 原生筛选 Select：统一 prefix + 等宽下拉的多选输入态 */
.filter-inline-select .arco-select-view-multiple {
  height: 32px !important;
  min-height: 32px !important;
  align-items: center;
}

.filter-inline-select .arco-select-view-multiple .arco-select-view-inner {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.filter-inline-select .arco-select-view-multiple .arco-select-view-tag {
  white-space: nowrap;
  flex-shrink: 0;
  max-width: none !important;
  margin-top: 0;
  margin-bottom: 0;
}

.filter-inline-select.arco-select-focused .arco-select-view-multiple {
  box-shadow: none !important;
}

/* 长文本下拉选项：允许换行，避免作品等筛选项被省略号截断 */
.arco-select-dropdown .arco-select-option {
  height: auto !important;
  min-height: 34px;
  align-items: flex-start;
  padding-top: 8px;
  padding-bottom: 8px;
}

.arco-select-dropdown .arco-select-option-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: anywhere;
}

/* 多选下拉项带 checkbox，不需要长文本换行高度；和普通单选项保持同一视觉高度 */
.arco-select-dropdown .arco-select-option:has(.arco-checkbox) {
  height: 34px !important;
  min-height: 34px;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.arco-select-dropdown .arco-select-option:has(.arco-checkbox) .arco-select-option-content {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 34px;
}

.arco-select-dropdown .arco-select-option:has(.arco-checkbox) .arco-checkbox {
  align-items: center;
  min-width: 0;
}

.arco-select-dropdown .arco-select-option:has(.arco-checkbox) .arco-checkbox-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 全局固定列基础稳定处理：先避免滚动时的视觉闪动，不强改 Arco 原生布局 */
.arco-table:has(.arco-table-th-fixed-left) .arco-table-th-fixed-left,
.arco-table:has(.arco-table-td-fixed-left) .arco-table-td-fixed-left,
.arco-table:has(.arco-table-th-fixed-right) .arco-table-th-fixed-right,
.arco-table:has(.arco-table-td-fixed-right) .arco-table-td-fixed-right,
.arco-table:has(.arco-table-cell-fixed-left) .arco-table-cell-fixed-left,
.arco-table:has(.arco-table-cell-fixed-right) .arco-table-cell-fixed-right {
  transition: none !important;
  backface-visibility: hidden;
}

.arco-table:has(.arco-table-th-fixed-left) .arco-table-th-fixed-left,
.arco-table:has(.arco-table-td-fixed-left) .arco-table-td-fixed-left,
.arco-table:has(.arco-table-th-fixed-right) .arco-table-th-fixed-right,
.arco-table:has(.arco-table-td-fixed-right) .arco-table-td-fixed-right {
  background: #fff;
}
</style>
